// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Contact from "./contact.js"
import PhotoSession from "./photo-session.js"
import PhotoSessionGroup from "./photo-session-group.js"
import PhotoSessionGroupContact from "./photo-session-group-contact.js"

const modelClassData = {
  "attributes": {
    "contact_id": {
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": "uuid"
      },
      "name": "contact_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_session_id": {
      "column": {
        "default": null,
        "name": "photo_session_id",
        "null": false,
        "type": "uuid"
      },
      "name": "photo_session_id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_session_group_id": {
      "column": {
        "default": null,
        "name": "photo_session_group_id",
        "null": true,
        "type": "uuid"
      },
      "name": "photo_session_group_id",
      "selected_by_default": null,
      "translated": null
    },
    "photo_session_group_contact_id": {
      "column": {
        "default": null,
        "name": "photo_session_group_contact_id",
        "null": true,
        "type": "uuid"
      },
      "name": "photo_session_group_contact_id",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "ContactPhotoSessionCurrent",
  "collectionKey": "contact_photo_session_currents",
  "collectionName": "contact_photo_session_currents",
  "i18nKey": "contact_photo_session_current",
  "camelizedLower": "contactPhotoSessionCurrent",
  "name": "ContactPhotoSessionCurrent",
  "nameDasherized": "contact-photo-session-current",
  "pluralName": "contact_photo_session_currents",
  "ransackable_associations": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "PhotoSession",
      "collectionName": "photo_sessions",
      "foreignKey": "photo_session_id",
      "name": "photo_session",
      "macro": "belongs_to",
      "resource_name": "PhotoSession",
      "through": null
    },
    {
      "className": "PhotoSessionGroup",
      "collectionName": "photo_session_groups",
      "foreignKey": "photo_session_group_id",
      "name": "photo_session_group",
      "macro": "belongs_to",
      "resource_name": "PhotoSessionGroup",
      "through": null
    },
    {
      "className": "PhotoSessionGroupContact",
      "collectionName": "photo_session_group_contacts",
      "foreignKey": "photo_session_group_contact_id",
      "name": "photo_session_group_contact",
      "macro": "belongs_to",
      "resource_name": "PhotoSessionGroupContact",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "contact_id",
      "column": {
        "default": null,
        "name": "contact_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "photo_session_group_contact_id",
      "column": {
        "default": null,
        "name": "photo_session_group_contact_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "photo_session_group_id",
      "column": {
        "default": null,
        "name": "photo_session_group_id",
        "null": true,
        "type": "uuid"
      }
    },
    {
      "name": "photo_session_id",
      "column": {
        "default": null,
        "name": "photo_session_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "contact_id",
      "name": "contact",
      "macro": "belongs_to",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "PhotoSession",
      "collectionName": "photo_sessions",
      "foreignKey": "photo_session_id",
      "name": "photo_session",
      "macro": "belongs_to",
      "resource_name": "PhotoSession",
      "through": null
    },
    {
      "className": "PhotoSessionGroup",
      "collectionName": "photo_session_groups",
      "foreignKey": "photo_session_group_id",
      "name": "photo_session_group",
      "macro": "belongs_to",
      "resource_name": "PhotoSessionGroup",
      "through": null
    },
    {
      "className": "PhotoSessionGroupContact",
      "collectionName": "photo_session_group_contacts",
      "foreignKey": "photo_session_group_contact_id",
      "name": "photo_session_group_contact",
      "macro": "belongs_to",
      "resource_name": "PhotoSessionGroupContact",
      "through": null
    }
  ],
  "paramKey": "contact_photo_session_current",
  "primaryKey": "id"
}

/** Frontend model for ContactPhotoSessionCurrent. */
export default class ContactPhotoSessionCurrent extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  contactId() {
    return this.readAttributeUnderscore("contact_id")
  }

  /** @returns {boolean} */
  hasContactId() {
    const value = this.contactId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string} */
  photoSessionId() {
    return this.readAttributeUnderscore("photo_session_id")
  }

  /** @returns {boolean} */
  hasPhotoSessionId() {
    const value = this.photoSessionId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  photoSessionGroupId() {
    return this.readAttributeUnderscore("photo_session_group_id")
  }

  /** @returns {boolean} */
  hasPhotoSessionGroupId() {
    const value = this.photoSessionGroupId()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  photoSessionGroupContactId() {
    return this.readAttributeUnderscore("photo_session_group_contact_id")
  }

  /** @returns {boolean} */
  hasPhotoSessionGroupContactId() {
    const value = this.photoSessionGroupContactId()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  findNextModel(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "find_next_model",
        primaryKey: this.primaryKey(),
        collectionName: "contact_photo_session_currents",
        type: "member"
      },
      commandArgs
    ))
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  findPreviousModel(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (this._callMemberCommand(
      {
        args,
        command: "find_previous_model",
        primaryKey: this.primaryKey(),
        collectionName: "contact_photo_session_currents",
        type: "member"
      },
      commandArgs
    ))
  }

  /** @returns {import("./contact.js").default | null} */
  contact() {
    return this._readBelongsToReflection({modelClass: Contact, reflectionName: "contact"})
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  loadContact() {
    if (!("contactId" in this)) throw new Error("Foreign key method wasn't defined: contactId")

    const id = this.contactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "contact",
        model: this,
        modelClass: Contact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./contact.js").default | null>} */
  ensureContactLoaded() {
    return this.ensureAssociationLoaded("contact")
  }

  /** @returns {import("./photo-session.js").default | null} */
  photoSession() {
    return this._readBelongsToReflection({modelClass: PhotoSession, reflectionName: "photo_session"})
  }

  /** @returns {Promise<import("./photo-session.js").default | null>} */
  loadPhotoSession() {
    if (!("photoSessionId" in this)) throw new Error("Foreign key method wasn't defined: photoSessionId")

    const id = this.photoSessionId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_session",
        model: this,
        modelClass: PhotoSession
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-session.js").default | null>} */
  ensurePhotoSessionLoaded() {
    return this.ensureAssociationLoaded("photo_session")
  }

  /** @returns {import("./photo-session-group.js").default | null} */
  photoSessionGroup() {
    return this._readBelongsToReflection({modelClass: PhotoSessionGroup, reflectionName: "photo_session_group"})
  }

  /** @returns {Promise<import("./photo-session-group.js").default | null>} */
  loadPhotoSessionGroup() {
    if (!("photoSessionGroupId" in this)) throw new Error("Foreign key method wasn't defined: photoSessionGroupId")

    const id = this.photoSessionGroupId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_session_group",
        model: this,
        modelClass: PhotoSessionGroup
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-session-group.js").default | null>} */
  ensurePhotoSessionGroupLoaded() {
    return this.ensureAssociationLoaded("photo_session_group")
  }

  /** @returns {import("./photo-session-group-contact.js").default | null} */
  photoSessionGroupContact() {
    return this._readBelongsToReflection({modelClass: PhotoSessionGroupContact, reflectionName: "photo_session_group_contact"})
  }

  /** @returns {Promise<import("./photo-session-group-contact.js").default | null>} */
  loadPhotoSessionGroupContact() {
    if (!("photoSessionGroupContactId" in this)) throw new Error("Foreign key method wasn't defined: photoSessionGroupContactId")

    const id = this.photoSessionGroupContactId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "photo_session_group_contact",
        model: this,
        modelClass: PhotoSessionGroupContact
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./photo-session-group-contact.js").default | null>} */
  ensurePhotoSessionGroupContactLoaded() {
    return this.ensureAssociationLoaded("photo_session_group_contact")
  }
}
